/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Share.UrlList.vb <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 27.8.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 27.8.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.EnppTicketList", jQuery.common.VisualBase, {
    delDialog: null,
    editDialog: null,
    chartDialog: null,
    selectedId: null,
    duration: null,

    _create: function () {
        var me = this;
        try {
           
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 339;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
           
            me._super();
         
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
          
            me.showMessage("", false);
          
            ////adopt heights and widths
            var h = parseInt(me.visual.height() -
                me.fnd(".vc-list-header").height() -
                me.fnd("#div-filter-menu").height());
            me.fnd(".lst-entries").height(parseInt(h));

          
        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {



            me._fetch();

            //generate the option boxes
            var htmlLogger = me.element.find(".log").clone();
            me.fnd(".log").replaceWith(
                $("<div>", { "class": "log-box box1 vc-grid-2col vc-grid-margin-right vc-grid-margin-bottom" })
            );
            me.fnd(".log-box").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.resources.logger, clickable: false, isList: true, content: htmlLogger.clone() }]
            });


            //add click handlers
            me.element.on("change", ".sub", function (e) {
                me._fetch();
                e.preventDefault();
            });

            me.element.on("click", ".vc-list-item", function (e) {
             
                window._VCMQ.produce(me.element, "-1", 'GET_EXPORT_URL_SETTINGS', { key: $(this).data("key") });

                $("#i-share-url").vcShareUrlIcon("show");
                e.stopPropagation();

            });




            me.element.on("click", ".vc-list .col5", function (e) {
                me.selectedId = parseInt(($(this).data("id")));
                me.delDialog.dialog('open');
                e.stopPropagation();
            });
        

            me.element.on("click", ".vc-list .col6", function (e) {
                me._showChart($(this));
                me.chartDialog.dialog('open');
                e.stopPropagation();
            });

            //add the dialog boxes
            me.delDialog = $("<div>").html(me.specific.resources.shouldEntryBeDeleted).dialog({
                autoOpen: false, width: 400, height: 130, title: me.resources.dialogTitle, modal: true,
                buttons: {
                    "ok": function () { me._delete(); me.delDialog.dialog('close'); },
                    "cancel": function () { me.delDialog.dialog('close'); }
                },
                dialogClass: 'saveDialog'
            });
            var editDiv = $("<div id='div-edit'>").html(me.element.find("#div-edit-duration").clone());
            editDiv.find("#div-edit-duration").show();
            me.editDialog = editDiv.dialog({
                autoOpen: false, width: 400, height: 130, title: me.resources.dialogTitle, modal: true,
                buttons: {
                    "ok": function () {
                        me.duration = parseInt($("#div-edit .dur").val());
                        me._editDuration();
                        me.editDialog.dialog('close');
                    },
                    "cancel": function () { me.editDialog.dialog('close'); }
                },

                dialogClass: 'saveDialog'
            });

            me.chartDialog = $("<div>", { id: 'div-chart-preview' }).width(960).height(490).html("").dialog({
                autoOpen: false, width: 1000, height: 600, title: me.resources.dialogTitle, modal: true,
                buttons: { "ok": function () {
                     me.chartDialog.dialog('close');
                }}, dialogClass: 'saveDialog'
            });

            $("#divDebug").append("<br/>url3");
        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries incl. filter options
        /// </summary>
        var me = this;
        var param;
        try {
          
            param = {};
          
            param.Bsaid = parseInt(me.fnd("#div-filter-menu .log").val());
        
            me.fnd(".lst-entries").html(me.getLoadingIcon());
         
            me.getData(param, function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
               }

                me._generateList(result);
               
                return true;
            });

        } catch (e) { me.writeError('_fetch', e); return false;}
        return true;
    },


    _delete: function () {
        /// <summary>
        /// This function deletes an existing entry
        /// </summary>
        var me = this;
        var param = {};
        try {

            if (me.selectedId == null) {
                me.showMessage(me.resources.err_loadData, true);
                return false;
            }

            param.type = 1;
            param.Id = me.selectedId;

            me.updateData(param, function (result) {
                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }

                me._fetch();
                return true;
            });

        } catch (e) { me.writeError('_delete', e); return false; }
        return true;
    },

    _generateList: function (dtt) {
        /// <summary>
        /// This function generates a list from the data and ...
        /// nothing too complicated
        /// </summary>
        var me = this;
        var item, col, col1, col2, col3, col4, col5, col6, col7;
        var list;
        var type;
        var valid;
        var sTmp;
        try {

            list = me.fnd(".lst-entries");
            list.html("");

            if (dtt === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
             
            if (dtt.rows === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
           

            for (var i = 0; i < dtt.rows.length; i++) {


                item = $("<div>", { "class": "vc-list-item" });

                item.append($("<div>", { "class": "vc-list-col col0" }).html($("<div>", { "class": "vc-list-col-element", "html": "Nr:" + dtt.rows[i].id })));
                item.append($("<div>", { "class": "vc-list-col col1" }).html($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].name })));
                item.append($("<div>", { "class": "vc-list-col col2" }).html($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].startdate })));
                item.append($("<div>", { "class": "vc-list-col col3" }).html($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].enddate })));
                item.append($("<div>", { "class": "vc-list-col col4" }).html($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].signals })));
             
                list.append(item);
            }

            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');

            return true;
        } catch (e) {
            me.writeError('_save', e); return false;
        }

    },


    _showChart: function (obj) {
        /// <summary>
        /// This function shows an chart
        /// </summary>
        var me = this;
        try {
           
            var myParam = JSON.parse(JSON.stringify(obj.data("settings")));
            me.container = me.getRandomIDContainerObj("div-chart-preview-", false);
         
            me.container.obj.height(490);
            me.container.obj.width(960);
            $("#div-chart-preview").html(me.container.obj);
            
            new window.vcVisual().addVisualBase('div-chart-preview-', myParam.VCVID, me.container.random, window.getCurrentTimestamp(), 490, 950, myParam.Parameter, myParam.SignalParameter, myParam.DeviceType);


        } catch (e) { me.writeError('_showChart', e); return false; }
        return true;
    },
    
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd(".lst-entries, #div-filter-menu").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

